import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IRefreshTokenMetaData {

    exp: number,
    iat: number,
    jti: string,


}

const refreshTokenMetaDataSlice = createSlice({
    name: "refreshTokenMetaData",
    initialState: {
        value: {
            exp: 0,
            iat: 0,
            jti: "",
        }
    },
    reducers: {
        updateRefreshTokenMetaData: (state, action: PayloadAction<IRefreshTokenMetaData>) => {
            state.value = action.payload;
        },
    },
});

export const { updateRefreshTokenMetaData } = refreshTokenMetaDataSlice.actions;


export const refreshTokenMetaDataReducer = refreshTokenMetaDataSlice.reducer;
